import { ContactsAutocomplete } from '@/components/ContactsAutocomplete';
import type { Props as ContactsAutocompleteProps } from '@/components/ContactsAutocomplete/ContactsAutocomplete';
import { CoAgentAutocompletePaper } from '$form-fields';

type Props = Omit<
  ContactsAutocompleteProps,
  | 'includeGoogleContacts'
  | 'includeFollowUpBossContacts'
  | 'excludeNonCompliantTeams'
  | 'freeSolo'
>;

/**
 * A autocomplete component that renders a list of co-agent contact suggestions.
 */
export const CoAgentAutocomplete = (props: Props) => {
  return (
    <ContactsAutocomplete
      includeGoogleContacts={false}
      includeFollowUpBossContacts={false}
      freeSolo={false}
      excludeNonCompliantTeams
      fixedHeight
      fullWidth
      PaperComponent={CoAgentAutocompletePaper}
      paperProps={{
        sx: {
          '& .MuiAutocomplete-noOptions': {
            pt: 0.5,
          },
          '& .MuiAutocomplete-listbox': {
            pt: 0,
          },
        },
      }}
      {...props}
    />
  );
};
